
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { SaleLayoutLogo, SaleLayoutLogoPosition } from "@/utils/sale-layouts/logo";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import { AWSFile } from "../../models/aws-file";
import { AWSFileService } from "../../services/aws-file-service";
import AppLogoExtraSettings from "./LogoExtraSettingsModal.vue";
import AppSelectPlacement from "./SelectPlacement.vue";

interface IImagePlacement {
	imgName: string;
	imgToken:string;
	imgUrl: string;
	awsFile: AWSFile;
	placement: SaleLayoutLogoPosition | "null";
}

export default Vue.extend({
	data() {
		return {
			allImages: [] as IImagePlacement[],
			sending: false,
			extraSettingsLogo: null as SaleLayoutLogo | null
		};
	},
	props: {
		logos: Array as () => SaleLayoutLogo[],
		fullControl: Boolean,
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	computed: {
		allowedExtensions():string[] {
			return ["jpg", "png", "jpeg"];
		},
	},
	watch: {
		allImages: {
			deep: true,
			handler() {
				for (let i = this.logos.length - 1; i >= 0; i--) {
					let logo = this.logos[i];
					let foundImage = this.allImages.find(img => img.imgToken == logo.ImageToken);
					if (!foundImage || foundImage.placement == "null") {
						this.logos.splice(i, 1);
						continue;
					}
					logo.Placement = foundImage.placement;
				}
				for (let img of this.allImages) {
					if (img.placement == "null") {
						continue;
					}
					let logo = this.logos.find(l => l.ImageToken == img.imgToken);
					if (!logo) {
						logo = new SaleLayoutLogo();
						logo.ImageToken = img.awsFile.Token;
						this.logos.push(logo);
					}
					logo.Placement = img.placement;
				}
			}
		}
	},
	methods: {
		async getAllImages() {
			let allImages = await AWSFileService.listFiles("/print-layouts");
			this.allImages = allImages.map(i => {
				let token = i.Token;
				let placed = this.logos.find(l => l.ImageToken == token);
				let placement = "null" as SaleLayoutLogoPosition | "null";
				if (placed) {
					placement = placed.Placement;
				}
				return {
					imgName: i.Name,
					imgToken: i.Token,
					imgUrl: i.getUrl(),
					placement,
					awsFile: i
				};
			});
		},
		async onFileInput(file: File) {
			this.sending = true;
			await AWSFileService.uploadFile("/print-layouts", file);
			this.getAllImages();
			this.sending = false;
		},
		async removeImg(awsFile: AWSFile) {
			await AWSFileService.deleteFiles([awsFile]);
			this.getAllImages();
		},
		encodeURI(uri:string):string {
			return encodeURI(uri);
		},
		editImageSettings(img:IImagePlacement){
			this.extraSettingsLogo = this.getLogoFromImage(img) || null;
		},
		getLogoFromImage(img:IImagePlacement):SaleLayoutLogo | undefined{
			return this.logos.find(l=>l.ImageToken == img.imgToken);
		},
	},
	async created() {
		this.getAllImages();
	},
	components: {
		AppFileUpload,
		AppLogoExtraSettings,
		AppSelectPlacement
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
